import { defineStore } from "pinia";
//
import { useMasterDataStore } from "./MasterDataStore";
export const usePerkawinanStatusStore = defineStore("perkawinanStatusStore", {
  state: () => ({
    data: null,
  }),
  onInit() {
    this.get();
  },
  persist: true,
  getters: {
    filter() {
      return this.data.filter((g) => g.nama);
    },
  },
  actions: {
    async get() {
      // if (!this.data) {
      //   try {
      //     const config = {
      //       headers: {
      //         Authorization: api.defaults.headers.common["Authorization"],
      //         "content-type": "application/json",
      //       },
      //     };
      //     const response = await axios.get( `${API_BASE_URL}/perkawinanStatus`,config);  // Replace with your API endpoint
      //     this.data = response.data;
      //   } catch (error) {
      //     console.error('perkawinanStatusStore Error fetching:', error);
      //   }
      // }
      if (!this.data) {
        const master = useMasterDataStore();
        const masterData = await master.get();

        this.data = masterData.perkawinanStatus || [];
        console.log("perkawinanstatus", this.data);
      }
      return this.data;
    },
    // reset(){
    //     this.data = null;
    //     this.get();
    // }

    async reset() {
      // Add async
      this.data = null; // Clear the store

      const newData = await this.get(); // Fetch new data

      this.data = newData; // Store the fetched data
      return this.data; // Ensure reset() returns the data
    },
  },
});
